<template>
  <div class="white">
   
    
   
     <v-row class="pa-14 grey lighten-4 mt-4">
       <v-col cols="12" xs="12" sm="12" md="5" lg="5" xl="5" class="mt-14">
         <h1 class="font-weight-regular green--text text--darken-4">Baking with a difference</h1>
         <h4 class="font-weight-regular green--text text--lighten-2">We use nothing but the highest quality ingredients in all of our from-scratch recipes. 
           No preservatives. No mixes. No shortcuts.</h4>
       </v-col>
        <v-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6" class="mt-14">
           <img class="ml-14 pl-5 d-none d-sm-flex" :src="require('../assets/showcase.jpg')" height="300"/>
            <img class=" d-flex d-sm-none" :src="require('../assets/showcase.jpg')" height="130"/>
        </v-col>
     </v-row>
     <Tab />
  </div>
</template>

<script>
import Tab from '../components/Homepage/Tab.vue'
 

  export default {
    components: {
        Tab
     
    },
  }
</script>
